module.exports = __webpack_public_path__ + "img/buttom.50ab01f4.png";